// import CrossIcon from "../../assets/Icons/CrossIcon";

// const Popup = ({ visible, onClose, children, outsideClickClose = true }) => {
//   if (!visible) return null;

//   const handleOnClose = (e) => {
//     if (outsideClickClose && e.target.id === "container") {
//       onClose();
//     }
//   };

//   return (
//     <div
//       id="container"
//       onClick={handleOnClose}
//       className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-50"
//     >
//       <div className="relative bg-white px-10 py-10 rounded ">
//         {/* Close button */}
//         <button
//           onClick={onClose}
//           className="absolute top-2 right-2 text-black hover:text-gray-800 text-xl font-bold p-2 hover:scale-90 transition-all delay-100"
//         >
//           <CrossIcon color="#1f2937"/>
//         </button>

//         {/* Popup content */}
//         {children}
//       </div>
//     </div>
//   );
// };

// export default Popup;

import CrossIcon from "../../assets/Icons/CrossIcon";

const Popup = ({
  visible,
  onClose,
  children,
  outsideClickClose = true,
  isCloseButton = false,
}) => {
  if (!visible) return null;

  const handleOnClose = (e) => {
    if (outsideClickClose && e.target.id === "container") {
      onClose();
    }
  };

  return (
    <div
      id="container"
      onClick={handleOnClose}
      className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm justify-center items-center z-50"
    >
      {isCloseButton ? (
        <div className="relative bg-white px-10 py-10 rounded ">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-black hover:text-gray-800 text-xl font-bold p-2 hover:scale-90 transition-all delay-100"
          >
            <CrossIcon color="#1f2937" />
          </button>

          {/* Popup content */}
          {children}
        </div>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export default Popup;
